@if (posts().length) {
  <section class="tw-bg-white tw-w-full tw-mb-2 tw-pt-7 tw-pb-4">
    <h2 class="tw-text-700 tw-font-bold tw-mb-4 tw-pl-4 tw-font-lexend" i18n="@@faqs">FAQs</h2>

    <swiper [config]="swiperConfig">
      @for (post of posts(); track post.objectId; let i = $index) {
        <span *swiperSlide type="button"
          class="tw-flex tw-flex-col tw-justify-between tw-w-[120px] tw-h-[138px] tw-rounded-2 tw-text-left tw-overflow-hidden tw-border tw-ml-3"
          [class.tw-mr-4]="i === posts().length -1"
          [class.tw-ml-4]="i === 0"
          (click)="openStory(post, i)">
          @if (post.slides[0]?.url || post.slides[0]?.thumbnailUrl) {
            <img class="tw-w-full tw-h-full tw-object-cover" [alt]="post.question"
              [src]="post.slides[0].thumbnailUrl || post.slides[0].url" />
          } @else {
            <div class="tw-w-full tw-h-full tw-bg-gray-500"></div>
          }
        </span>
      }
    </swiper>
  </section>
}

@if (activeIndex() >= 0) {
  <app-story-viewer #reel [stories]="posts()" [startStoryIndex]="activeIndex()" [startSlideIndex]="storyStartIndex"
    [videoType]="videoType"
    (tapNavigate)="onStoryTap($event)" (closed)="closeStory()" (completed)="closeStory()">

    <!-- Slide body: full-bleed image / video -->
    <ng-template #storySlide let-slide>
      <div class="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-bg-white">
        @if (slide.type === videoType) {
          <video-player class="tw-w-full" [src]="slide.url" [poster]="slide.thumbnailUrl"
            [autoplay]="true" [loop]="false" [paused]="reel.paused()"
            (timeUpdate)="reel.notifyVideoProgress($event)" (onVideoEnd)="reel.notifyVideoEnded()"></video-player>
        } @else {
          <img class="tw-w-full tw-h-full tw-object-contain" alt="" [src]="slide.url" />
        }
      </div>
    </ng-template>

    <!-- Footer: CTA on the last slide of a post that has one, otherwise the fixed doctor patch -->
    <ng-template #storyFooter let-story="story" let-isLastSlide="isLastSlide">
      @if (isLastSlide && story.ctaText) {
        <div class="tw-px-6 tw-pb-10">
          <button type="button" (click)="onCtaClick(story)"
            class="tw-w-full tw-bg-[#0E796C] tw-text-white tw-rounded-lg tw-py-3 tw-font-medium tw-border-0">
            {{ story.ctaText }}
          </button>
        </div>
      } @else {
        <div class="tw-flex tw-items-center tw-gap-2 tw-px-6 tw-pb-10">
          <div class='tw-w-10 tw-h-10 tw-rounded-full tw-overflow-hidden'>
            <img class="tw-w-full tw-h-full tw-object-cover tw-rounded-full tw-object-top " alt="" [src]="doctorPatch.imageUrl" />
          </div>
          <div class="tw-flex tw-flex-col">
            <span class="tw-font-lexend tw-text-200 tw-font-semibold tw-text-gray-800 tw-leading-3">{{ doctorPatch.name }}</span>
            <span class="tw-font-lexend tw-text-100 tw-text-gray-500 tw-font-light">{{ doctorPatch.title }}</span>
          </div>
        </div>
      }
    </ng-template>
  </app-story-viewer>
}
